import {
  AutomationStatus,
  TriggerType,
  ExecutionStatus,
  IntegrationNodeType,
} from '../types';

export const AUTOMATION_STATUS_LABELS: Record<AutomationStatus, string> = {
  Draft: 'Draft',
  Active: 'Active',
  Paused: 'Paused',
  Archived: 'Archived',
};

export const TRIGGER_TYPE_LABELS: Record<TriggerType, string> = {
  BusinessEvent: 'Business Event',
  HttpWebhook: 'HTTP Webhook',
  Schedule: 'Schedule',
};

// Alias for consistency with other label exports
export const AUTOMATION_TRIGGER_TYPE_LABELS = TRIGGER_TYPE_LABELS;

export const EXECUTION_STATUS_LABELS: Record<ExecutionStatus, string> = {
  Pending: 'Pending',
  Running: 'Running',
  WaitingApproval: 'Waiting Approval',
  Completed: 'Completed',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
};

export const NODE_TYPE_LABELS: Record<IntegrationNodeType, string> = {
  Trigger: 'Trigger',
  Action: 'Action',
  Condition: 'Condition',
  Delay: 'Delay',
};

export const DEFAULT_FLOW_DEFINITION = {
  nodes: [],
  edges: [],
};

// Status options for filters
export const AUTOMATION_STATUS_OPTIONS: AutomationStatus[] = [
  'Draft',
  'Active',
  'Paused',
  'Archived',
];
export const TRIGGER_TYPE_OPTIONS: TriggerType[] = [
  'BusinessEvent',
  'HttpWebhook',
  'Schedule',
];
export const EXECUTION_STATUS_OPTIONS: ExecutionStatus[] = [
  'Pending',
  'Running',
  'WaitingApproval',
  'Completed',
  'Failed',
  'Cancelled',
];
